var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-marker-wrapper"},[_c('img',{staticClass:"custom-marker",attrs:{"width":"30px","height":"30px","src":"/themes/custom/ef2_custom_v2/img/marker.svg"},on:{"click":_vm.toggle}})])
}
var staticRenderFns = []

export { render, staticRenderFns }